import { useEffect } from 'react';
import { MODE_DARK, MODE_LIGHT } from '@/constants/theme.constant.ts';
import { useThemeStore } from '@/store/themeStore';

export const useThemeSchema = () => {
  const mode = useThemeStore((state) => state.mode);

  useEffect(() => {
    if (window !== undefined) {
      const root = window.document.documentElement;
      root.classList.remove(mode === MODE_DARK ? MODE_LIGHT : MODE_DARK);
      root.classList.add(mode === MODE_DARK ? MODE_DARK : MODE_LIGHT);
    }
  }, [mode]);
};
